import { defineFcm } from '../shared/factory';

export const FCM_STARFISH_STARTER_DM_RECOMMENDER = defineFcm('starfish_starter_dm_recommender')
	.asBoolean()
	.withDefault(false)
	.withMerger(({ localeValue, countryValue }) => localeValue && countryValue)
	.toConfig();
